var map = {
	"./template.bet575": 1553,
	"./template.bet575.tsx": 1553,
	"./template.bet777": 1554,
	"./template.bet777.tsx": 1554,
	"./template.betprofessor": 1555,
	"./template.betprofessor.tsx": 1555,
	"./template.betroyale": 1556,
	"./template.betroyale.tsx": 1556,
	"./template.betstride": 1557,
	"./template.betstride.tsx": 1557,
	"./template.buffalobet": 1558,
	"./template.buffalobet.tsx": 1558,
	"./template.chromabet": 1559,
	"./template.chromabet.tsx": 1559,
	"./template.default": 667,
	"./template.default.tsx": 667,
	"./template.epicodds": 1560,
	"./template.epicodds.tsx": 1560,
	"./template.fiestabet": 1561,
	"./template.fiestabet.tsx": 1561,
	"./template.gigabet": 1562,
	"./template.gigabet.tsx": 1562,
	"./template.goldenbet888": 1563,
	"./template.goldenbet888.tsx": 1563,
	"./template.goldenrush": 1564,
	"./template.goldenrush.tsx": 1564,
	"./template.hyperbet": 1565,
	"./template.hyperbet.tsx": 1565,
	"./template.juicybet": 1566,
	"./template.juicybet.tsx": 1566,
	"./template.junglebet": 1567,
	"./template.junglebet.tsx": 1567,
	"./template.magnumbet": 1568,
	"./template.magnumbet.tsx": 1568,
	"./template.puntcity": 1569,
	"./template.puntcity.tsx": 1569,
	"./template.questbet": 1570,
	"./template.questbet.tsx": 1570,
	"./template.slambet": 1571,
	"./template.slambet.tsx": 1571,
	"./template.templebet": 1572,
	"./template.templebet.tsx": 1572,
	"./template.titanbet": 1573,
	"./template.titanbet.tsx": 1573,
	"./template.ts": 979,
	"./template.vikingbet": 1574,
	"./template.vikingbet.tsx": 1574,
	"./template.volcanobet": 1575,
	"./template.volcanobet.tsx": 1575,
	"./template.wellbet": 1576,
	"./template.wellbet.tsx": 1576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2446;